"use strict";

exports.__esModule = true;
var _RoleListContext = require("./RoleListContext");
Object.keys(_RoleListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleListContext[key]) return;
  exports[key] = _RoleListContext[key];
});
var _getRoleName = require("./getRoleName");
Object.keys(_getRoleName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getRoleName[key]) return;
  exports[key] = _getRoleName[key];
});